<template>
	<div>
		<!-- <home-tile color="danger" style="padding-top: 0px; margin-top: 10px">
			<span class="tile-text-small">
				<h3>Alert</h3>
				We are aware of an issue that may have resulted in a duplication
				of your monthly donation. We are working to refund any duplicate
				charges now.
			</span>
		</home-tile> -->
		<screen class="home-view" type="white">
			<div class="home-backdrop"></div>
			<div class="home-inner" v-if="!hasTOS">
				<div class="center" v-if="!hasTOS">
					<img
						src="@/assets/legal.svg"
						v-bind:style="{ height: '150px' }"
					/>
					<h2>
						We've updated our Terms of Service and Privacy Policy.
					</h2>
					<p>
						We made it easier to read, and included langauge about
						how roundups and donations are processed.
					</p>
					<div class="welcome-actions">
						<ui-button :loading="isSaving" @click="accept"
							>Accept and Continue</ui-button
						>
						<p v-bind:style="{ fontSize: '8px' }">
							By continuing you agree to the new
							<a
								href="https://roundupapp.com/terms/"
								target="_blank"
								>Terms of Service</a
							>
							and
							<a
								href="https://roundupapp.com/privacy/"
								target="_blank"
								>Privacy Policy</a
							>.
						</p>
					</div>
				</div>
			</div>
			<div v-else class="home-inner">
				<thank-tile
					v-if="cause.type === 'org' && home.institution"
					:institution="home.institution"
				>
					<p
						slot="text"
						style="font-family: 'Bitter'; color: #71788c"
					>
						{{ cause.fact }}
					</p>
					<h3 slot="org" style="color: #111111 !important">
						{{ home.institution.name }}
					</h3>
				</thank-tile>
				<group-thank-tile v-if="cause.type === 'group'" />

				<share-tile v-if="home.institution" />

				<home-tile
					color="purple"
					button-title="Complete Your Account"
					@click="
						() =>
							this.navigate({ name: 'settings.user' }, 'forward')
					"
					v-if="missingProfileInfo"
				>
					We could use a little more information about you!
				</home-tile>

				<home-tile
					v-if="home.unlinkedAccounts > 0"
					color="danger"
					button-title="View Accounts"
					@click="showAccounts"
				>
					<h3
						type="light"
						style="margin-top: 10px; color: white !important"
					>
						Account Connection Error
					</h3>
					<p>
						We are having trouble connecting to one of your
						accounts. It could be that a password has changed.
						Please go to settings and double check your accounts.
					</p>
				</home-tile>

				<expired-card-tile />
				<roundups-error-tile />
				<roundups-error-tile-1 />

				<roundups-tile />

				<home-tile
					color="mint"
					button-title="View Details"
					@click="showDonations"
				>
					<img
						src="@/assets/smiles.svg"
						style="width: 150px; margin-top: -30px"
					/>
					<h3
						type="light"
						style="margin-top: 10px; color: white !important"
					>
						Your Giving
					</h3>
					<div class="roundup-row snapshot">
						<div style="min-width: 150px">
							<p>This Month</p>
							<h2 class="light" v-if="currentMonthlyTotal">
								${{ currentMonthlyTotal.toFixed(2) }}
							</h2>
							<h2 class="light" v-else>–</h2>
						</div>
						<div style="min-width: 150px">
							<p>Goal</p>
							<h2 class="light">
								${{ (minDonation / 100).toFixed(2) }}
							</h2>
						</div>
					</div>
					<span class="tile-text-small" style="padding: 0 20px"
						>Your donation on {{ nextDonationDate }} will be ${{
							Math.max(nextDonation, minDonation / 100).toFixed(2)
						}}
						<img
							@click="showNextDonationModal()"
							:style="{
								height: '1em',
								marginLeft: '5px',
								cursor: 'pointer'
							}"
							src="@/assets/info.svg"
						/>
					</span>
					<hr />
					<div
						class="roundup-row"
						style="
							width: 70%;
							justify-content: space-between;
							margin: auto;
							margin-bottom: 20px;
							padding: auto 20px;
						"
					>
						<div>
							<p>Current RoundUps</p>
							<h2 class="light">
								{{ home.pendingTransactions }}
							</h2>
						</div>
						<div>
							<p>Last Donation</p>
							<h2
								class="light"
								v-if="home.lastRoundup && !failedPayout"
							>
								${{ home.lastRoundup.toFixed(2) }}
							</h2>
							<h2 class="light" v-else>–</h2>
						</div>
					</div>
				</home-tile>

				<whole-dollar-tile v-if="hasAccounts && wholeDollar == 0" />

				<home-tile
					v-if="
						home.institution &&
						home.institution.designation_count > 0
					"
					color="pink"
					:button-title="
						home.designation ? 'Change Campaign' : 'Pick Campaign'
					"
					@click="showDesignations"
				>
					<span class="tile-text-small" v-if="home.designation">
						Your current campaign is to:
						{{ home.designation.title }}
					</span>
					<span class="tile-text-small" v-else>
						We have multiple areas you can give to specifically.
						Would you like to pick a campaign?
					</span>
				</home-tile>

				<donate-extra-tile />

				<multiplier-tile />

				<blank-tile
					@click.native="navigate({ name: 'settings' }, 'forward')"
				>
					<template slot="image"
						><img src="@/assets/settings.svg"
					/></template>
					<span slot="title">Settings</span>
				</blank-tile>

				<notification></notification>
				<logo />
				<modal v-model="nextDonationModal" size="medium">
					<h3>What is this?</h3>
					<p>
						We process donations at the end of each month to
						minimize costs for your organization. Your donation will
						represent either the sum of your roundups OR your
						monthly donation goal, whichever is larger. If you have
						not linked accounts for roundups, you will give your
						goal each month. To change your monthly goal, please go
						to settings.
					</p>
				</modal>
			</div>
		</screen>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Routes from '../../router/async-routes'

import Screen from '../../ui/Screen'
import HomeTile from './HomeTile'
import ThankTile from './ThankTile'
import GroupThankTile from './GroupThankTile'
import BlankTile from './BlankTile'
import RoundupsTile from './RoundupsTile'
import RoundupsErrorTile from './RoundupsErrorTile'
import RoundupsErrorTile1 from './PayoutErrorCountTile'
import WholeDollarTile from './WholeDollarTile'
import Notification from '../../ui/Notification'
import UiButton from '../../ui/Button'
import Logo from '../../ui/Logo'
import Modal from '../../ui/Modal'
import ShareTile from './ShareTile'
import MultiplierTile from './MultiplierTile'
import DonateExtraTile from './DonateExtraTile'
import ExpiredCardTile from './ExpiredCardTile'

export default {
	name: 'home-view',
	components: {
		Screen,
		HomeTile,
		ThankTile,
		BlankTile,
		RoundupsTile,
		Notification,
		UiButton,
		RoundupsErrorTile,
		RoundupsErrorTile1,
		ShareTile,
		Logo,
		Modal,
		MultiplierTile,
		WholeDollarTile,
		DonateExtraTile,
		ExpiredCardTile,
		GroupThankTile
	},
	data() {
		return {
			isSaving: false,
			nextDonationModal: false
		}
	},
	computed: {
		...mapState({
			home: ({ home }) => home.item
		}),
		...mapGetters([
			'nextDonation',
			'nextDonationDate',
			'hasAccounts',
			'user',
			'failedPayout',
			'hasTOS',
			'minDonation',
			'wholeDollar',
			'lastDonationDate',
			'currentMonthlyTotal',
			'cause',
			'missingProfileInfo'
		])
	},
	methods: {
		...mapActions(['getHome', 'finishSignup', 'acceptTOS']),
		showAccounts() {
			this.navigate({ name: 'accounts' }, 'forward')
		},
		showDonations() {
			this.navigate({ name: 'roundups' }, 'forward')
		},
		showDesignations() {
			this.navigate({ name: 'designations' }, 'forward')
		},
		accept() {
			this.isSaving = true
			this.acceptTOS()
				.then(() => {
					this.isSaving = false
					this.$router.go()
				})
				.catch(({ message }) => {
					this.isSaving = false
					this.$swal('Error', message)
				})
		},
		toDate(date) {
			const localDate = new Date(new Date(date).toString() + ' UTC')

			const day = localDate.getDate()
			const monthIndex = localDate.getMonth()
			const year = localDate.getFullYear()

			return monthIndex + 1 + '/' + day + '/' + year
		},
		showNextDonationModal() {
			this.nextDonationModal = true
		}
	},
	mounted() {
		this.getHome()
		if (
			!this.user.has_completed_signup &&
			!(localStorage.getItem('roundup_skip') || false)
		) {
			this.finishSignup()
		}

		Routes.preloadHome()
	}
}
</script>

<style lang="scss">
@import '../../styles/elements';
.screen.home-view {
	h3 {
		color: white !important;
	}
	background: $bone;
	overflow: hidden;
	position: relative;

	.home-inner {
		position: relative;
		margin-left: -35px;
		margin-right: -35px;
		padding: 0 10px;
		z-index: 1;
		@media screen and (max-width: 480px) {
			margin-left: -25px;
			margin-right: -25px;
		}
	}
	.home-row {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 10px;
	}
	.home-backdrop {
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		background: $bone;
		height: 400px;
		z-index: 0;
	}
	.center {
		display: flex;
		flex-direction: column;
		align-content: center;
		justify-content: center;
		text-align: center;
	}
	.snapshot {
		padding-left: 20px;
		padding-right: 20px;
		width: 80%;
		justify-content: space-between;
		margin: auto;
		margin-bottom: 20px;
		flex-wrap: wrap;
		align-items: center;
		@media screen and (max-width: 480px) {
			justify-content: center;
		}
	}
}
</style>
